import { render, staticRenderFns } from "./StorageStatement.vue?vue&type=template&id=aa4dc8f2"
import script from "./StorageStatement.vue?vue&type=script&lang=js"
export * from "./StorageStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4dc8f2')) {
      api.createRecord('aa4dc8f2', component.options)
    } else {
      api.reload('aa4dc8f2', component.options)
    }
    module.hot.accept("./StorageStatement.vue?vue&type=template&id=aa4dc8f2", function () {
      api.rerender('aa4dc8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Storage/StorageStatement.vue"
export default component.exports